// extracted by mini-css-extract-plugin
module.exports = {"titleText":"e_Ju","container":"e_Ku","authorText":"e_Lu","title":"e_Mu","image":"e_Nu","description":"e_Ou","author":"e_Pu","splitLine":"e_Qu"};